export default "__VITE_ASSET__EEJT_k4k__"